import { Directive, OnInit } from '@angular/core';
import { BaseDapperReadListPage, DwGridDataSourceService, FieldTypes } from '@digiwall/ag-grid';
import { LocalizationService } from '@abp/ng.core';
import { ColDef } from '@ag-grid-community/core';
import { GoliathDocumentEntityNames } from '../../constants/entity-names.constants';
import { IDapperReadEntityService, QueryDTO } from '@digiwall/core';

@Directive()
export abstract class OpenOrderLinesListComponent<
    TDto extends QueryDTO<string>,
    TService extends IDapperReadEntityService<TDto>,
  >
  extends BaseDapperReadListPage<TDto, TService>
  implements OnInit
{
  protected GoliathDocumentEntityNames: any = GoliathDocumentEntityNames;

  override colDefs: ColDef[] = [
    {
      field: 'orderDayBookCode',
      headerName: this.localizationService.instant('Doc::OpenOrderLines:OrderDayBookCode'),
      type: FieldTypes.String,
    },
    {
      field: 'orderDisplayNumber',
      headerName: this.localizationService.instant('Doc::OpenOrderLines:OrderDisplayNumber'),
      type: FieldTypes.String,
    },
    {
      field: 'orderDate',
      headerName: this.localizationService.instant('Doc::OpenOrderLines:OrderDate'),
      type: FieldTypes.Date,
    },
    {
      field: 'articleCode',
      headerName: this.localizationService.instant('Doc::OpenOrderLines:ArticleCode'),
      type: FieldTypes.String,
    },
    {
      field: 'articleName',
      headerName: this.localizationService.instant('Doc::OpenOrderLines:ArticleName'),
      type: FieldTypes.String,
    },
    {
      field: 'orderedQuantity',
      headerName: this.localizationService.instant('Doc::SupplierDeliveryNote:OrderedQuantity'),
      type: FieldTypes.Number,
      cellRendererParams: {
        decimals: 2,
      },
    },
    {
      field: 'cancelledQuantity',
      headerName: this.localizationService.instant('Doc::CustomerSalesPurchase:CancelledQuantity'),
      type: FieldTypes.Number,
      cellRendererParams: {
        decimals: 2,
      },
    },
    {
      field: 'backorderQuantity',
      headerName: this.localizationService.instant('Doc::OpenOrderLines:BackorderQuantity'),
      type: FieldTypes.Number,
      cellRendererParams: {
        decimals: 2,
      },
    },
  ];

  constructor(
    service: TService,
    datasource: DwGridDataSourceService,
    protected localizationService: LocalizationService,
  ) {
    super(service, datasource);
  }
}
